import { render, staticRenderFns } from "./searchMail.vue?vue&type=template&id=5f804fc4&scoped=true"
import script from "./searchMail.vue?vue&type=script&lang=js"
export * from "./searchMail.vue?vue&type=script&lang=js"
import style0 from "./searchMail.vue?vue&type=style&index=0&id=5f804fc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f804fc4",
  null
  
)

export default component.exports